import { useStaticQuery, graphql } from 'gatsby'

export const useLatestBlogsQuery = () => {
  const { wpPage, allWpPost, wp } = useStaticQuery(graphql`
    query OurLatestBlogsQuery {
      wpPage(title: { eq: "Home" }) {
        latestBlogs {
          latestBlogs {
            title
            backgroundImage {
              localFile {
                childImageSharp {
                  gatsbyImageData(formats: WEBP, layout: FULL_WIDTH)
                }
              }
            }
          }
        }
      }
      allWpPost(limit: 3, sort: { date: DESC }) {
        nodes {
          featuredImage {
            node {
              localFile {
                childImageSharp {
                  gatsbyImageData(layout: FULL_WIDTH, formats: [WEBP])
                }
              }
            }
          }
          postFeaturedImageAltText {
            altText
          }
          date(formatString: "MMM DD, YYYY")
          title
          excerpt
          link
        }
      }
      wp {
        acfOptionsCommonItems {
          commonItems {
            post {
              heroImageDefault {
                localFile {
                  childImageSharp {
                    gatsbyImageData(formats: [WEBP])
                  }
                }
              }
              heroImageDefaultAltText
            }
          }
        }
      }
    }
  `)
  return { wpPage, allWpPost, wp }
}
